import React from "react";
import logo from "../images/header.jpg";

export default () => (
  <header className="App-header">
    <img src={logo} alt="Reverend Susan Rainwater" />
  </header>
);
